import { render, staticRenderFns } from "./tableSocketProcess.vue?vue&type=template&id=64bc85c4&"
import script from "./tableSocketProcess.vue?vue&type=script&lang=js&"
export * from "./tableSocketProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports